import React from 'react';
import PropTypes from 'prop-types';

const MobileClosedPositionActiveRow = ({children}) => {
	return (
			<div className="mobile-closed-position__active__row">
				{children}
			</div>
	);
};

MobileClosedPositionActiveRow.defaultProps = {
	children: <></>,
};

MobileClosedPositionActiveRow.propTypes = {
	children: PropTypes.node,
};

export default MobileClosedPositionActiveRow;
